import ShowFiles from "../../sites/DetailsPages/file";

export default function SelectFilesCompany({id}) {
  return <ShowFiles id={id} type="company" />;
}
